module.exports = __webpack_public_path__ + "static/pic11-02b4e615ca62dbf2fb899ff5a8926a0f.png";